import React from "react";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../sims/style";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { ReportSchema } from "./Schema";

export const GradeCrossingAccidentReport = (props) => {
  const { reportData } = props;
  let injectedUserData = ReportGroupingUtils.injectUserInfoInReportData(reportData, props.userList);
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(injectedUserData);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(reportsByDateAndUser);

  return decodedReports.map((report, i) => {
    return <ViewReport key={i} data={report} {...props} />;
  });
};

const ViewReport = (props) => {
  const { data, title, userList } = props;
  const { decodedData, email } = data;

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      {decodedData.map((singleReport, index) => {
        return (
          <div key={index}>
            <ReportTitleSection title={title} fontSizeOverride={"35px"} />
            <ReportFraInfoSectionContainer {...props} data={{ ...data }} />
            <span className="spacer"></span>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <p style={{ margin: 0 }}>
                <b>DEPARTMENT OF TRANSPORTATION</b> <br />
                FEDERAL RAILROAD ADMINISTRATION (FRA)
              </p>
              <p style={{ margin: 0 }}>
                <b>OMB No. 2130-0500</b>
              </p>
            </div>
            <table className="table-bordered">
              {ReportSchema.map((schema, i) => (
                <ReportTableSectionRenderer rowsData={singleReport.summary} section={schema} />
              ))}
            </table>
            <div>
              <div style={{ display: "flex", gap: "40px", alignItems: "center" }}>
                <p style={{ fontSize: "20px", fontWeight: "bold", margin: 0 }}>FORM FRA F 6180.57 (Rev. 08/10)</p>
                <p style={{ fontSize: "13px", margin: 0 }}>*NOTE THAT ALL CASUALTIES MUST BE REPORTED ON FORM FRA F 6180.55A</p>
              </div>

              <br />

              <p style={{ fontSize: "20px", fontWeight: "bold", margin: 0 }}>OMB approved 12/05/2023, Approval expires 12/31/2026</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/HighBall/GradeCrossingAccidentReport/index.jsx